export default __webpack_public_path__ + "static/media/trash_veryDarkGrey.c6fe9945.svg";